<template>
  <div class="evaluation-info">
    <el-row>
      <el-col :span="16">
        <table class="table">
          <tr>
            <td>Fecha de aplicación </td>
            <td>{{ evaluation.startDate | date('ll') }} al {{ evaluation.endDate | date('ll') }}</td>
          </tr>
        </table>
      </el-col>
      <el-col
        :span="6"
        :push="2"
      >
        <table class="table">
          <tr>
            <td>Estatus</td>
            <td>{{ evaluation.status | status }}</td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <h1>{{ layout.name }}</h1>
    <h2>Departamento: {{ evaluation.division }}</h2>
    <p class="description">
      {{ evaluation.description || "Esta evaluación no contiene descripción" }}
    </p>
    <br>
    <el-button
      type="primary"
      @click="$emit('start')"
    >
      INICIAR EVALUACIÓN
    </el-button>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import statusFilter from '@/filters/status.filter'

export default {
  name: 'EvaluationInfo',
  filters: {
    status: statusFilter
  },
  props: {
    assignment: {
      type: Object,
      default () {
        return {}
      }
    },
    branch: {
      type: Object,
      required: true
    },
    layout: {
      type: Object,
      required: true
    },
    evaluation: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.evaluation-info {
  padding: 40px;
  .table {
    border: 1px solid #dddddd;
    border-collapse: collapse;
    td:first-child {
      background-color: #f0f0f0;
    }
    td {
      padding: 7px 20px;
    }
  }
  h1 {
    margin: 0;
    margin-top: 40px;
    @include font-primary(32px, bold);
  }
  h2 {
    margin: 0;
    @include font-primary(18px, semibold);
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-info.vue